import axios from 'axios'

// 创建一个专门用于外部服务的请求实例
const AiRequest = axios.create({
  baseURL: 'http://192.168.185.57:5000', // 你的新服务地址
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器（如果需要）
AiRequest.interceptors.request.use(
  config => {
    // 如果外部服务需要认证，可以在这里添加
    // const token = localStorage.getItem('externalToken')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
AiRequest.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('外部服务请求错误:', error)
    return Promise.reject(error)
  }
)

export default AiRequest